import { Token } from '@uniswap/sdk'
import { useState, useEffect } from 'react'
import { useActiveWeb3React } from './index'
import { detectTokenTaxSafely, getKnownTokenTaxInfo, TokenTaxInfo } from '../utils/taxDetection'

// 重新导出接口
export type { TokenTaxInfo }

// React Hook for 检测代币税费
export function useTokenTaxDetection(token: Token | undefined): TokenTaxInfo {
  const { library, account } = useActiveWeb3React()
  const [taxInfo, setTaxInfo] = useState<TokenTaxInfo>({
    hasTax: false,
    isKnownTaxToken: false,
    recommendedSlippage: 0
  })

  useEffect(() => {
    if (!(token instanceof Token)) {
      setTaxInfo({
        hasTax: false,
        isKnownTaxToken: false,
        recommendedSlippage: 0
      })
      return
    }

    const knownTokenTaxInfo = getKnownTokenTaxInfo(token.chainId, token.address)
    if (knownTokenTaxInfo) {
      setTaxInfo(knownTokenTaxInfo)
      return
    }

    if (!library || !account) {
      setTaxInfo({
        hasTax: false,
        isKnownTaxToken: false,
        recommendedSlippage: 0
      })
      return
    }

    // 异步检测代币税费
    detectTokenTaxSafely(token, library, account)
      .then(result => {
        setTaxInfo(result)
      })
      .catch(error => {
        console.debug('Error in tax detection:', error)
        setTaxInfo({
          hasTax: false,
          isKnownTaxToken: false,
          recommendedSlippage: 0
        })
      })
  }, [token, library, account])

  return taxInfo
}